<mat-dialog-content style="min-width: 280px; display: flex; flex-direction: column" *ngIf="data && !isSmallScreen">

  <div style="min-height: 48px; display: flex; align-items: center">
    <span class="expansion-panel-title-copy">{{'WORKFLOW_DETAILS' | translate}}</span>
  </div>
  <div style="display: flex; flex-flow: row wrap; gap: 12px 24px">
    <div style="flex: 1; display: flex; flex-direction: column; min-width: 212px; gap: 6px" *ngFor="let item of getworkflowDetails()">
      <p class="data-title"><strong>{{item.label | translate}}</strong></p>
      <p>{{item.value ? item.value : '-'}}</p>
    </div>
  </div>

  <mat-divider style="margin-top: 14px;" class="lighter-border-color"></mat-divider>

  <div style="min-height: 48px; display: flex; align-items: center">
    <span class="expansion-panel-title-copy">{{'TASK_DETAILS' | translate}}</span>
  </div>
  <div style="display: flex; flex-flow: row wrap; gap: 12px 24px">
    <div style="flex: 1; display: flex; flex-direction: column; min-width: 212px; gap: 6px" *ngFor="let item of getTaskDetails()">
      <p class="data-title"><strong>{{item.label | translate}}</strong></p>
      <p>{{item.value ? item.value : '-'}}</p>
    </div>
  </div>

</mat-dialog-content>

<h2 mat-dialog-title *ngIf="isSmallScreen">{{'DETAILS' | translate}}</h2>
<mat-dialog-content *ngIf="data && isSmallScreen" class="dialog-height-fix">

  <mat-tab-group class="tab-header-height-fix">
    <mat-tab label="{{'WORKFLOW' | translate}}">
      <div style="display: flex; flex-flow: row wrap; gap: 12px 24px; padding-top: 12px">
        <div style="flex: 1; display: flex; flex-direction: column; min-width: 212px; gap: 4px" *ngFor="let item of getworkflowDetails()">
          <p class="data-title"><strong>{{item.label | translate}}</strong></p>
          <p>{{item.value ? item.value : '-'}}</p>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'TASK' | translate}}">
      <div style="display: flex; flex-flow: row wrap; gap: 12px 24px; padding-top: 12px">
        <div style="flex: 1; display: flex; flex-direction: column; min-width: 212px; gap: 4px" *ngFor="let item of getTaskDetails()">
          <p class="data-title"><strong>{{item.label | translate}}</strong></p>
          <p>{{item.value ? item.value : '-'}}</p>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>

<!--<mat-dialog-content style="min-width: 280px; display: flex; flex-direction: column" *ngIf="data && isSmallScreen">-->

<!--  <mat-tab-group>-->
<!--    <mat-tab label="{{'WORKFLOW' | translate}}">-->
<!--      <div style="display: flex; flex-flow: row wrap; margin-top: 8px">-->
<!--        <div style="display: flex; flex-direction: column; width: 250px;" *ngFor="let item of getworkflowDetails()">-->
<!--          <p style="font-size: 14px; color: #000000DE; margin-bottom: 0"><strong>{{item.label | translate}}</strong></p>-->
<!--          <p style="margin-bottom: 8px">{{item.value}}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </mat-tab>-->
<!--    <mat-tab label="{{'TASK' | translate}}">-->
<!--      <div style="display: flex; flex-flow: row wrap; margin-top: 8px">-->
<!--        <div style="display: flex; flex-direction: column; width: 250px;" *ngFor="let item of getTaskDetails()">-->
<!--          <p style="font-size: 14px; color: #000000DE; margin-bottom: 0"><strong>{{item.label | translate}}</strong></p>-->
<!--          <p style="margin-bottom: 8px">{{item.value ? item.value : '-'}}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </mat-tab>-->
<!--  </mat-tab-group>-->

<!--</mat-dialog-content>-->

<mat-dialog-actions align="end" style="margin: 0 24px 12px 24px">
  <button mat-stroked-button mat-dialog-close style="margin: 0">{{'OK' | translate}}</button>
</mat-dialog-actions>
